// extracted by mini-css-extract-plugin
module.exports = {"login":"styles_login__3uhzH","login__title":"styles_login__title__i-39y","login__links":"styles_login__links__1j61w","signup":"styles_signup__3maR9"};